import { render, staticRenderFns } from "./MergeCustomerData.vue?vue&type=template&id=d833c410&scoped=true"
import script from "./MergeCustomerData.vue?vue&type=script&lang=js"
export * from "./MergeCustomerData.vue?vue&type=script&lang=js"
import style0 from "./MergeCustomerData.vue?vue&type=style&index=0&id=d833c410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d833c410",
  null
  
)

export default component.exports